export const NewQuestionActionTypes = {
    TOGGLE_QUESTION_PAGE_HIDDEN: 'TOGGLE_QUESTION_PAGE_HIDDEN'
};